import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-html-notes',
  templateUrl: './html-notes.component.html',
  styleUrls: ['./html-notes.component.scss']
})
export class WidgetHtmlNotesComponent implements OnInit {
  static key = 100202
  
  @Input('config') config:any = {}
  @Input('item') item:any
  @Output('onSizeChange') onSizeChange = new EventEmitter<any>();
  @ViewChild('htmlDiv', { static: true }) htmlDiv!: ElementRef;
  
  constructor() { }

  ngOnInit(): void {
    // Auto Height
    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.htmlDiv.nativeElement);
  }

}
